// Base
import Head from 'next/head'

// Components
import MainLayout from '@components/v25/ft1/MainLayout'
import Trustpilot from '@components/v25/trustpilot/Trustpilot'

// Sections
import HomepageWrapper from '@sections/v25/ft1/homepage/HomepageWrapper'
import HowItWorksWrapper from '@sections/v25/ft1/homepage/how-it-works/HowItWorksWrapper'
import RecentDeals from '@sections/v25/ft1/homepage/recent-deals/RecentDeals'
import CustomerExperiences from '@sections/v25/ft1/customer-experiences/CustomerExperiences'
import FacebookReviews from '@sections/v25/ft1/homepage/facebook-reviews/FacebookReviews'
import FAQ from '@components/v25/ft1/faq/FAQ'
import InternationalTripWrapper from '@sections/v25/ft1/homepage/international-trip/InternationalTripWrapper'

// Images
import BeachBackground from '@images/v25/ft1/photos/beach-background.png'

// Data
import experiences from '@data/v25/ft1/experiences.json'

export default function Home() {
  return (
    <>
      <Head>
        <title>RatePunk Premium</title>
        <meta name="description" content="RatePunk Premium" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      <MainLayout backgroundColor="#FCF8FC">
        <HomepageWrapper redirectURL="/v25/membership" />

        <RecentDeals redirectURL="/v25/membership" />

        <Trustpilot theme="black" />

        <HowItWorksWrapper redirectURL="/v25/membership" />

        <CustomerExperiences
          title="Our customer experiences"
          redirectURL="/v25/membership"
          experiences={experiences.slice(0, 2)}
        />

        <FacebookReviews redirectURL="/v25/membership" />

        <FAQ theme="black" padding={[32, 0, 64]} />

        <InternationalTripWrapper
          backgroundImage={BeachBackground}
          title="Take international trip this year and save up to 90% on flights."
          features={[
            'Get instant <b>email alerts</b> when cheap flights pop up.',
            'Get notified when airlines accidentally publish <b>wrong prices</b>.',
            'Get <b>best offers</b> on summer, peak season and holiday flights.'
          ]}
          redirectURL="/v25/membership"
          spacing={64}
        />
      </MainLayout>
    </>
  )
}
